import { createAuthRedirect } from 'utils/authRedirect'
import { browserHistory, buildStudyRoutePath } from 'utils/navigation'

const LockRedirect = (studyID, studyVersionID, path = 'compliance') =>
  createAuthRedirect({
    authenticatedSelector: state => !state.studyLock,
    redirectPath: buildStudyRoutePath(studyID, studyVersionID, path),
    redirectAction: newLoc => () => {
      browserHistory.replace(newLoc)
    },
    wrapperDisplayName: 'LockRedirect',
  })

export default LockRedirect
